module.exports = __webpack_public_path__ + "img/waxfren_mc5wo.wam.d46a3f3.png";